import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";
import { BaseLink } from "~/components/common/base-link";

export const StoryCardCarouselItemContainer = styled.div`
  position: relative;

  display: block;

  padding-block-start: 4px;

  text-align: center;
`;

export const StyledBaseImage = styled(BaseImage)``;

export const StyleCardItemSectionName = styled.div`
  color: #666666;
  font-size: 10px;
  font-family: ${fontRobotoCondensed};
  line-height: 12px;
`;

export const StyledBaseLink = styled(BaseLink)`
  inline-size: 64px;
  block-size: 92px;

  border-radius: 4px;

  overflow: hidden;
`;

export const RedDotIcon = styled.span`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: auto;
  inset-inline-end: -3px;
  z-index: 1;

  inline-size: 10px;
  block-size: 10px;

  border-radius: 10px;

  background-color: #eb4254;
`;
